import { useState } from "react";
import {
  Box,
  Card,
  CardContent,
  TextField,
  Button,
  Typography,
  Link,
  LinearProgress,
  Alert,
} from "@mui/material";
import { signUp } from "../../services/Access";
import { t } from "i18next";

export default function SignUp(props) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);

  const handleClickSignUp = () => {
    setLoading(true);
    setSuccess(false);
    setError("");
    if (password !== confirmPassword) {
      setError("As senhas não coincidem"); /*trad */
      setLoading(false);
      return;
    }
    signUp({ email, password, confirmPassword })
      .then(() => {
        setSuccess(true); /*trad */
      })
      .catch((e) => {
        if (e.response?.data?.msg === "2") {
          setError("As senhas não coincidem"); /*trad */
        } else if (e.response?.data?.msg === "3") {
          setError(
            "A senha deve ter pelo menos 4 e no máximo 150 caracteres",
          ); /*trad */
        } else if (e.response?.data?.msg === "4") {
          setError(
            "A senha deve conter pelo menos uma letra maiúscula, uma letra minúscula, um caractere especial e um número",
          ); /*trad */
        } else if (e.response?.data?.msg === "5") {
          setError("Formato do email inválido"); /*trad */
        } else if (e.response?.data?.msg === "6") {
          setError("Email muito longo"); /*trad */
        } else if (e.response?.data?.msg === "7") {
          setError("Email já existe"); /*trad */
        } else {
          setError("Erro ao criar conta"); /*trad */
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Box sx={{ width: 400 }}>
        <Card elevation={3}>
          <CardContent>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: 2,
                alignItems: "center",
              }}
            >
              <Box
                component="img"
                src="./img/login-logo.png"
                alt="Logo"
                sx={{ pt: 4, pb: 4 }}
              />
              {success ? (
                <Box
                  sx={{
                    alignItems: "flex-start",
                  }}
                >
                  <Typography variant="body1">
                    {t("emailConfirmationSent")} <b>{email}</b>.
                  </Typography>
                  <br />
                  <Typography variant="body1">
                    {t("checkYourSpamFolder")}
                  </Typography>
                  <br />
                  <Typography variant="body1">
                    {t("trySigningUpAgain")}
                  </Typography>
                </Box>
              ) : (
                <>
                  <TextField
                    label={t("email")}
                    fullWidth
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                  <TextField
                    label={t("password")}
                    type="password"
                    fullWidth
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                  <TextField
                    label={t("confirmPassword")}
                    type="password"
                    fullWidth
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        handleClickSignUp();
                      }
                    }}
                  />
                  <Button
                    variant="contained"
                    fullWidth
                    onClick={handleClickSignUp}
                    disabled={loading}
                  >
                    {t("createNewAccount")}
                  </Button>{" "}
                  {loading && (
                    <Box sx={{ width: "100%" }}>
                      <LinearProgress />
                    </Box>
                  )}
                  {error && (
                    <Box sx={{ width: "100%" }}>
                      <Alert variant="outlined" severity="error">
                        {error}
                      </Alert>{" "}
                    </Box>
                  )}
                </>
              )}
            </Box>
          </CardContent>
        </Card>

        <Box
          sx={{
            mt: 2,
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Link href="#" underline="hover" onClick={() => props.setFormType(1)}>
            <Typography variant="body2">{t("backToLogin")}</Typography>
          </Link>
        </Box>
      </Box>
    </Box>
  );
}
